import React from "react";

import {
  Link,
} from "react-router-dom";

import {
  FaShieldAlt,
  FaFileInvoiceDollar,
  FaChartBar,
  FaChevronRight,
} from "react-icons/fa";

import Footer from "../components/Footer";

import "../css/home.css";
import "../css/footer.css";

const items = [
  {
    to: "/polizasseguros",
    icon: FaFileInvoiceDollar,
    titulo: "Pólizas y facturación",
    descripcion:
      "Administración de pólizas, vehículos, vencimientos y pagos",
  },

  {
    to: "/informeseguros",
    icon: FaChartBar,
    titulo: "Informe de seguros",
    descripcion:
      "Consulta de pólizas, coberturas, vencimientos y pagos",
  },
];

const HomeSeguros = () => {
  return (
    <>
      <main className="danlu-subhome">
        {/* CABECERA */}

        <section className="danlu-subhome-hero seguros">
          <div className="danlu-subhome-main-icon">
            <FaShieldAlt />
          </div>

          <div className="danlu-subhome-title">
            <span>
              MÓDULO
            </span>

            <h1>
              Gestión de Seguros
            </h1>

            <p>
              Pólizas, vehículos,
              vencimientos, facturación
              y pagos
            </p>
          </div>
        </section>

        {/* OPCIONES */}

        <section className="danlu-subhome-grid seguros">
          {items.map(
            ({
              to,
              icon: Icon,
              titulo,
              descripcion,
            }) => (
              <Link
                key={to}
                to={to}
                className="danlu-subhome-card seguros"
              >
                <div className="danlu-subhome-card-icon">
                  <Icon />
                </div>

                <div className="danlu-subhome-card-body">
                  <h3>
                    {titulo}
                  </h3>

                  <p>
                    {descripcion}
                  </p>
                </div>

                <div className="danlu-subhome-arrow">
                  <FaChevronRight />
                </div>
              </Link>
            )
          )}
        </section>
      </main>

      <Footer />
    </>
  );
};

export default HomeSeguros;